import axios from "axios";
import {API_URL} from "./index";
import log from "loglevel";

class TagsService {
    getAll = () => {
        const url = API_URL.tags();
        return axios.get(url).catch(err => log.debug(err));
    };
    create = tag => {
        const url = API_URL.tags();
        return axios.post(url,tag).catch(err => log.debug(err));
    };
    edit = tag => {
        const url = API_URL.tags();
        return axios.put(url,tag).catch(err => log.debug(err));
    };
    filter = params => {
        const url = API_URL.tags("filter");
        return axios.get(url, {params}).catch(err => log.debug(err));
    };
}

export default new TagsService();